import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SectionInfo } from '../modules/components/section-info-side-drawer/interface';
import { IMentor, IBookingEvent } from '../types';
import { LikeMindedState } from './store';

interface ToastInfo {
  open: boolean;
  type?: string;
  content?: string;
}

export interface RedirectUrl {
  pathname: string;
  search: string;
}

interface CommonSlice {
  redirectUrl?: RedirectUrl;
  mentor?: IMentor;
  sectionInfo?: SectionInfo;
  offering?: IBookingEvent;
  toast?: ToastInfo;
}

const initialState = {} as CommonSlice;

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    addMentor(
      state,
      action: PayloadAction<{ mentor?: IMentor; recommendationId?: string }>,
    ) {
      state.mentor = action.payload.mentor;
    },
    addSectionInfo(
      state,
      action: PayloadAction<{ sectionInfo?: SectionInfo }>,
    ) {
      state.sectionInfo = action.payload.sectionInfo;
    },
    addOffering(state, action: PayloadAction<{ offering?: IBookingEvent }>) {
      state.offering = action.payload.offering;
    },
    addToastInfo(state, action: PayloadAction<{ toastInfo?: ToastInfo }>) {
      if (state.toast?.open) {
        state.toast = { ...state.toast, ...action.payload.toastInfo };
      } else {
        state.toast = action.payload.toastInfo;
      }
    },
    addRedirectUrl(state, action: PayloadAction<RedirectUrl>) {
      state.redirectUrl = action.payload;
    },
  },
});

export const commonReducer = commonSlice.reducer;
export const selectCommon = (state: LikeMindedState) => state.common;
export const {
  addMentor,
  addSectionInfo,
  addToastInfo,
  addOffering,
  addRedirectUrl,
} = commonSlice.actions;
